<template>
  <div class='illness'>
    <div>
      <div
        v-for="(i,k) in data"
        :key='k'
      >
        <p style="color:#0079FE;font-size:16px;">{{i.name}}</p>
        <div class="boxshadow">

          <a-popover
            style="cursor:pointer;"
            placement="bottom"
            v-for="(item,index) in i.arr"
            :key="index"
          >
            <template slot="content">
              <p>{{item.descInfo || '暂无疾病描述'}}</p>
            </template>
            <div :class="{box:true , point:item.descInfo}">
              <p>{{item.name}}</p>
              <div
                class="attention hp_center"
                @click="toCollect(item)"
              >
                <icon-font
                  :class="{active:item.favorite}"
                  type="icon-guanzhu1"
                />
              </div>
            </div>
          </a-popover>
          <!-- <div
        class="box"
        v-for="(item, index) in list"
        :key="index"
      >
        <p>{{item.name}}</p>
        <div class="attention hp_center">
          <icon-font type="icon-guanzhu1" />
        </div>
      </div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { getDisease } from "@/api/index";
import { submitFavorite, cancelFavorite } from "@/api/registered";
import { ls } from "@/utils/tool";
import noData from "@/components/NoData";
export default {
  components: {
    // noData,
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 999,
      },
      data: [
        { name: "前十疾病", type: 1, arr: [] },
        { name: "常见疾病", type: 2, arr: [] },
        { name: "流行病", type: 3, arr: [] },
      ],
      favorite: true,
      hospitals: [],
      hospitalTotalPage: 1,
      currPage: 1,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let that = this;
      this.data.forEach((i) => {
        that.initDisease(i.type);
      });
    },
    async initDisease(type) {
      let data = { ...this.form };
      data.type = type;
      let res = await getDisease(data);
      if (res.code == 200) {
        this.data[type - 1].arr = res.data.list;
      }
    },
    async toCollect(item) {
      if (!ls.get("token")) {
        this.$message.warning("请登录后再收藏!");
        this.$router.push("/login");
        return;
      }
      if (item.favorite) {
        let res = await cancelFavorite({
          memberId: ls.get("sysUser").id,
          objectId: item.id,
          objectType: 5,
        });
        if (res.code == 200) {
          this.init();
        }
      } else {
        let res = await submitFavorite({
          memberId: ls.get("sysUser").id,
          objectId: item.id,
          objectType: 5,
        });
        if (res.code == 200) {
          this.init();
        }
      }
    },
  },
};
</script>
<style lang="less">
.illness {
  padding: 5px;
  > div {
    width: 100%;
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    // box-shadow: 0 0 6px #ccc;
    > div {
      margin-top: 10px;
      p {
        margin: 0;
      }
      .boxshadow {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        // justify-content: space-between;
        .box {
          width: 15%;
          padding: 10px 15px;
          margin-top: 15px;
          margin-right: 15px;
          //   border: 1px solid #e3edff;
          background: #e3edff;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          //   &:hover {
          //     background: grey;
          //     color: #fff;
          //   }
          p {
            margin: 0;
          }
          .attention {
            padding: 5px;
          }
        }
        .point {
          cursor: pointer;
        }
      }
    }
  }
  .active {
    color: #d81e06;
  }
}
</style>
